import { Auth0Provider } from '@auth0/auth0-react';
import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

interface Auth0ProviderWithNavigateProps {
	children: ReactNode;
}

export const Auth0ProviderWithNavigate: React.FC<Auth0ProviderWithNavigateProps> = ({ children }) => {
	const navigate = useNavigate();

	const domain = process.env.REACT_APP_PES_AUTH0_DOMAIN as string | undefined;
	const clientId = process.env.REACT_APP_PES_AUTH0_CLIENT_ID as string | undefined;
	const redirectUri = process.env.REACT_APP_PES_AUTH0_CALLBACK_URL as string | undefined;
	const audience = process.env.REACT_APP_PES_AUTH0_AUDIENCE as string | undefined;

	const onRedirectCallback = (appState?: { returnTo?: string }) => {
		navigate(appState?.returnTo || window.location.pathname);
	};

	if (!(domain && clientId && redirectUri)) {
		return null;
	}

	return (
		<Auth0Provider
			domain={domain}
			clientId={clientId}
			authorizationParams={{
				redirect_uri: redirectUri,
				audience,
			}}
			onRedirectCallback={onRedirectCallback}
		>
			{children}
		</Auth0Provider>
	);
};
